import { createSlice, current } from '@reduxjs/toolkit';
import { showSuccessToast } from '../../app/utils/tostify';
import { t } from 'i18next';
import { addNewProduct, checkNewItemNumber, deleteNewProductList, editNewProduct, getNewInventoryProductList, getNewProductList, getProductCount, updateNewProductStatus } from '../apis/ProductV2APIs';
import { showSuccess } from '../../app/utils/sweetAlert';
interface initialStateInterFace {
	error: any;
	loading: boolean;
	allTheData: any;
	advanceData: any;
	currentPage: number;
	newProductList: Array<any>;
	inventoryProductList: Array<any>;
	count: number;
	selectedList: any;
	searchKey: string;
	searchKeyInventory: string;
}
const initialState: initialStateInterFace = {
	loading: false,
	error: [],
	newProductList: [],
	inventoryProductList: [],
	allTheData: {},
	advanceData: {},
	currentPage: 1,
	count: 0,
	selectedList: { varientList: [], mainproductList: [] },
	searchKey: '',
	searchKeyInventory: ''
};
const newproductSlice = createSlice({
	name: 'newproductSlice',
	initialState,
	reducers: {
		removeAllData(state, action) {
			state.error = action.payload;
		},
		addDataInTheLocalState(state, action) {
			state.allTheData = action.payload;
		},
		updataAllData(state, action) {
			const data = structuredClone(current(state?.allTheData));
			data.managedVariantData[action.payload.index] =
				action?.payload?.data;
			state.allTheData = data;
		},
		updatePorductList(state, action) {
			state.newProductList = action?.payload;
		},
		addDataInTheLocalStateAdvance(state, action) {
			state.advanceData = action.payload;
		},
		addDataIntoTheList(state, action) {
			// console.log(state.selectedList.varientList);
			if (
				action.payload.type == 'VARIENT' ||
				action.payload.type == 'MAIN'
			) {
				// console.log(action.payload);
				switch (action.payload.type) {
					case 'VARIENT':
						state.selectedList.varientList.push(
							action.payload.data
						);
						state.selectedList.varientList =
							state.selectedList.varientList.filter(
								(item: any) => item
							);
						// !state.selectedList.varientList.map((item: any) => item.id).includes(action.payload.data.id) ?
						//     state.selectedList.varientList.push(action.payload.data) :
						//     state.selectedList.varientList = state.selectedList.varientList.filter((i: any) => i.id !== action.payload.data.id);
						// console.log(action.payload.product._id, action.payload?.product.product_variants?.length, 5656);
						// if (state.selectedList.varientList.length == action.payload.product?.product_variants?.length) {
						//     console.log(action.payload.product._id, action.payload.product, 5656);
						//     !state.selectedList.mainproductList.map((item: any) => item.id).includes(action.payload.product._id) ?
						//         state.selectedList.mainproductList.push({ id: action.payload.product._id, is_active: action.payload.product.is_active }) :
						//         state.selectedList.mainproductList = state.selectedList.mainproductList.filter((i: any) => i.id !== action.payload.product._id)
						// }
						break;
					case 'MAIN':
						!state.selectedList.mainproductList
							.map((item: any) => item.id)
							.includes(action.payload.data.id)
							? state.selectedList.mainproductList.push(
								action.payload.data
							)
							: (state.selectedList.mainproductList =
								state.selectedList.mainproductList.filter(
									(i: any) =>
										i.id !== action.payload.data.id
								));
						break;
					default:
						break;
				}
			}
		},
		addItemToList(state, action) {
			// console.log(action.payload);
			switch (action.payload.type) {
				case 'VARIENT':
					state.selectedList.varientList.push(action.payload.data);
					state.selectedList.varientList =
						state.selectedList.varientList.filter(
							(item: any) => item
						);
					break;
				case 'MAIN':
					state.selectedList.mainproductList.filter(
						(i: any) => i.id !== action.payload.data.id
					);
					state.selectedList.mainproductList.push(
						action.payload.data
					);
					state.selectedList.mainproductList =
						state.selectedList.mainproductList.filter(
							(obj: any, index: any) =>
								state.selectedList.mainproductList.findIndex(
									(item: any) => item.id === obj.id
								) === index
						);
					break;
				default:
					break;
			}
		},
		removeDataIntoTheList(state, action) {
			switch (action.payload.type) {
				case 'VARIENT':
					state.selectedList.varientList =
						state.selectedList.varientList.filter(
							(i: any) => i.id !== action.payload.data.id
						);
					break;
				case 'MAIN':
					state.selectedList.mainproductList =
						state.selectedList.mainproductList.filter(
							(i: any) => i.id !== action.payload.data.id
						);
					break;
				default:
					break;
			}
		},
		addALlLnTheList(state, action) {
			state.selectedList.varientList = action.payload.varientList;
			state.selectedList.mainproductList = action.payload.mainproductList;
		},
		updateCurrentPage(state, action) {
			state.currentPage = action.payload;
		},
		handleSearchKey(state, action) {
			state.searchKey = action.payload;
		},
		handleSearchKeyInventory(state, action) {
			state.searchKeyInventory = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(addNewProduct.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addNewProduct.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(addNewProduct.rejected, (state: initialStateInterFace) => {
			state.loading = false;
		});
		builder.addCase(
			getNewProductList.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
				state.advanceData = {};
				state.allTheData = {};
			}
		);
		builder.addCase(
			getNewProductList.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.newProductList = action?.payload?.data?.list;
				state.count = action?.payload?.data?.count;
				state.error = '';
			}
		);
		builder.addCase(
			getNewProductList.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			editNewProduct.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			editNewProduct.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			editNewProduct.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			deleteNewProductList.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			deleteNewProductList.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				// showSuccessToast({ message: t(action.payload.message) })
			}
		);
		builder.addCase(
			deleteNewProductList.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			updateNewProductStatus.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			updateNewProductStatus.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(
			updateNewProductStatus.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(checkNewItemNumber.fulfilled, (state) => {
			state.loading = false;
		});
		builder.addCase(checkNewItemNumber.rejected, (state) => {
			state.loading = false;
		});
		builder.addCase(
			getNewInventoryProductList.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
				state.advanceData = {};
				state.allTheData = {};
			}
		);
		builder.addCase(
			getNewInventoryProductList.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.inventoryProductList = action?.payload?.data?.list;
				state.count = action?.payload?.data?.count;
				state.error = '';
			}
		);
		builder.addCase(
			getNewInventoryProductList.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(getProductCount.fulfilled, (state) => {
			state.loading = false;
		});
		builder.addCase(getProductCount.rejected, (state) => {
			state.loading = false;
		});
	}
});
export const {
	removeAllData,
	addItemToList,
	addDataInTheLocalState,
	updatePorductList,
	addDataInTheLocalStateAdvance,
	updataAllData,
	addDataIntoTheList,
	addALlLnTheList,
	removeDataIntoTheList,
	updateCurrentPage,
	handleSearchKey,
	handleSearchKeyInventory
} = newproductSlice.actions;
export default newproductSlice.reducer;
